import { useState } from 'react';

const faqs = [
  {
    q: '17c.cc 是什么平台？',
    a: '17c.cc 是一个优质的综合服务平台，为用户提供官方入口导航、详细使用指南、功能介绍及常见问题解答。无论您是新手还是资深用户，都能在 17c.cc 找到所需的信息和帮助。',
  },
  {
    q: '如何找到 17c.cc 的官方入口？',
    a: '17c.cc 官方入口即本站（17c.cc），请认准此域名。建议将本站加入浏览器书签，避免通过搜索引擎点击来路不明的链接，以保障账号和数据安全。',
  },
  {
    q: '17c.cc 注册需要哪些信息？',
    a: '注册 17c.cc 账号只需提供有效的电子邮箱或手机号码，并设置安全密码即可。注册过程简单快捷，通常只需 1-2 分钟即可完成。',
  },
  {
    q: '17c.cc 有哪些核心功能？',
    a: '17c.cc 提供数据管理、智能分析、团队协作、安全防护等丰富的核心功能。具体功能介绍请查看「功能介绍」分类页面获取详细信息。',
  },
  {
    q: '17c.cc 的最新地址是什么？',
    a: '17c.cc 的唯一官方域名即为 17c.cc，目前没有使用其他镜像地址或备用域名。请始终通过 17c.cc 访问平台，以确保您的账号安全。',
  },
  {
    q: '如何保障 17c.cc 账号安全？',
    a: '建议使用强密码并定期更换，开启双重验证功能，不要与他人共享账号，定期检查登录设备记录。更多安全建议请查阅「安全中心」相关文章。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
            17c.cc 常见问题
          </h2>
          <p className="text-foreground-500 text-base">
            快速了解 17c.cc 最常被问到的问题
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="rounded-xl bg-background-50 border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
              >
                <span className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {faq.q}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-foreground-400 text-lg transition-transform duration-300 flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`px-6 transition-all duration-300 overflow-hidden ${
                  openIndex === index ? 'pb-5 max-h-96' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}